module.exports = __webpack_public_path__ + "static/media/jules_interiors-IG-3.88bc5626.PNG";